import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { IonicModule } from '@ionic/angular';

import { SocialLoginModalPage } from './social-login-modal.page';

@NgModule({
  declarations: [SocialLoginModalPage],
  imports: [CommonModule, IonicModule, TranslateModule.forChild()],
  exports: [SocialLoginModalPage],
})
export class SocialLoginModalPageModule {}
